import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import aboutImg from "../../assets/AboutUs.jpeg";
import "./AboutSection.css";

const AboutSection = () => {
  return (
    <section className="about-agency-section">
      <Container style={{marginTop:"50px"}}>
        {/* Header Row */}
        <Row className="mb-4">
          <Col xs={12}>
            {/* <h2 className="section-title-text">ABOUT ASCENT BRANDWORKS</h2> */}
            {/* <div className="segmented-line-container">
              <div className="segmented-line">
                {lineColors.map((color, index) => (
                  <div
                    key={index}
                    style={{ backgroundColor: color }}
                    className="line-segment"
                  ></div>
                ))}
              </div>
            </div> */}
          </Col>
        </Row>

        <Row className="align-items-center justify-content-center g-4 g-lg-5">
          {/* Left Side: Image Section */}
          <Col lg={5} md={10} xs={12} className="d-flex justify-content-center">
            <div className="about-image-layout">
              <div className="vertical-labels">
                <span>DEVELOPMENT</span>
                <span>DIGITAL MARKETING</span>
                <span>DESIGNING</span>
              </div>

              <motion.div
                className="square-img-wrapper"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
              >
                <img
                  src={aboutImg}
                  alt="Workspace"
                  className="about-square-img"
                />
              </motion.div>
            </div>
          </Col>

          {/* Right Side: Text Content */}
          <Col lg={6} md={10} xs={12} style={{padding:"30px"}}>
            <motion.div
              className="about-text-content"
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <h3 className="about-headline">
                SHAPING BRANDS WITH PURPOSE AND PRECISION
              </h3>
              <p className="about-description">
                Welcome to Ascent Brandworks, your trusted partner in
                transforming visions into impactful realities. As a creative
                advertising agency with a handful of experience, we specialize
                in crafting powerful brands that tell your story and connect
                deeply with your audience.
              </p>
              <p className="about-description">
                At Ascent Brandworks, creativity meets strategy to drive your
                brand to new heights. Whether you’re a startup looking to build
                a strong brand identity or an established business seeking fresh
                innovation, our dedicated team is here to inspire, collaborate,
                and deliver results.
              </p>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutSection;
